import React, { useEffect, useMemo, useState } from 'react';

import { buildListingSeoCopy } from '../../util/listingSeoCopy';
import {
  enrichmentParamsFromPublicData,
  fetchListingEnrichment,
  getCachedListingEnrichment,
  setCachedListingEnrichment,
} from '../../util/listingEnrichmentClient';

import css from './ListingPage.module.css';

/**
 * Templated hub links above the Location map on event listing pages.
 * Prefer venue/city discovery hubs; fall back to keyword search when hubs are not live.
 */
const SectionListingNearbyLinks = ({
  title,
  publicData,
  description = '',
  marketplaceName = 'PromoTix',
}) => {
  const params = useMemo(() => enrichmentParamsFromPublicData(publicData), [publicData]);
  const cacheKey = params ? JSON.stringify(params) : null;
  const [enrichment, setEnrichment] = useState(() => getCachedListingEnrichment(cacheKey));

  useEffect(() => {
    if (!cacheKey || typeof fetch !== 'function') {
      return;
    }
    const cached = getCachedListingEnrichment(cacheKey);
    if (cached) {
      setEnrichment(cached);
      return;
    }
    let cancelled = false;
    fetchListingEnrichment(params).then(body => {
      setCachedListingEnrichment(cacheKey, body);
      if (!cancelled) {
        setEnrichment(body);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [cacheKey, params]);

  const seo = useMemo(
    () =>
      buildListingSeoCopy({
        title,
        publicData,
        description,
        marketplaceName,
        enrichment,
      }),
    [title, publicData, description, marketplaceName, enrichment]
  );

  const links = (seo?.nearbyLinks || []).filter(l => l.path);
  if (!links.length) {
    return null;
  }

  return (
    <div className={css.sectionListingNearbyLinks}>
      <ul className={css.seoNearbyList}>
        {links.map(link => (
          <li key={link.key}>
            <a className={css.seoAsideLink} href={link.path}>
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SectionListingNearbyLinks;
